"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ANALYTICS_ROI_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ANALYTICS_ROI_TRACKING;
  }
});
Object.defineProperty(exports, "AUTOMATED_EMAIL_RESPONSES", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.AUTOMATED_EMAIL_RESPONSES;
  }
});
Object.defineProperty(exports, "BUILDING_AND_PERSONALIZING_EMAILS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.BUILDING_AND_PERSONALIZING_EMAILS;
  }
});
Object.defineProperty(exports, "CRM_LEAD_INTEGRATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CRM_LEAD_INTEGRATION;
  }
});
Object.defineProperty(exports, "CUSTOMIZATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.CUSTOMIZATION;
  }
});
Object.defineProperty(exports, "DRIP_CAMPAIGNS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.DRIP_CAMPAIGNS;
  }
});
Object.defineProperty(exports, "LANDING_PAGES_WEB_FORMS", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.LANDING_PAGES_WEB_FORMS;
  }
});
Object.defineProperty(exports, "LEAD_SCORING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.LEAD_SCORING;
  }
});
Object.defineProperty(exports, "MARKETING_LEAD_DATABASE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.MARKETING_LEAD_DATABASE;
  }
});
Object.defineProperty(exports, "ONLINE_BEHAVIOR_TRACKING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.ONLINE_BEHAVIOR_TRACKING;
  }
});
Object.defineProperty(exports, "PROGRESSIVE_PROFILING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.PROGRESSIVE_PROFILING;
  }
});
Object.defineProperty(exports, "SALES_INTELLIGENCE", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SALES_INTELLIGENCE;
  }
});
Object.defineProperty(exports, "SEARCH_MARKETING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SEARCH_MARKETING;
  }
});
Object.defineProperty(exports, "SEGMENTATION", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SEGMENTATION;
  }
});
Object.defineProperty(exports, "SOCIAL_MARKETING", {
  enumerable: true,
  get: function get() {
    return _CategoryFeature.SOCIAL_MARKETING;
  }
});

var _CategoryFeature = require("../CategoryFeature");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/categoryFeatures/Automation.js
// module id = 562
// module chunks = 209 210 211 212 213